import React, { useEffect } from "react";
import CustomInputs from "../../../../../../Component/DigitalMarketing/CustomInputs";
import useHandleChangeHooks from "../../../../../../hooks/digitalMarketing/useHandleChangeHooks";
import { useGetCarePackageListsQuery } from "../../../../../../Service/CarePackages";
import useSnackbar from "../../../../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../../../../Component/DigitalMarketing/Toast";
import { useAddPatientCarePackagesMutation } from "../../../../../../Service/PatientList";
import BackdropLoader from "../../../../../../Component/DigitalMarketing/BackDropLoader";
import { useParams } from "react-router-dom";
import CustomVioletButton from "../../../../../../Component/DigitalMarketing/CustomVioletButton";

const AddCarePackages = (props: any) => {
  const { id } = useParams();
  const { setShowAdd, refetchCarePackage } = props;
  const { formData, setFormData, handleChange, submit, setSubmit } =
    useHandleChangeHooks({});
  const { open, message, openSnackBar, type } = useSnackbar();
  const { data: carePackageData } = useGetCarePackageListsQuery<any>({
    refetchOnMountOrArgChange: true,
  });

  const [addPatientCarePackages, { isLoading: addLoading }] =
    useAddPatientCarePackagesMutation();
  const carePackageOptions = carePackageData?.map((item: any) => ({
    value: item.id,
    label: item.packageName,
    validityPeriod: item.validityPeriod, // Add validity period to the care package data
  }));
  
  const paymentModes = [
    { id: "Online", label: "Online Payment" },
    { id: "Cash", label: "Cash" },
    { id: "Card", label: "Card" },
  ];

  const fields = [
    {
      type: "select",
      label: "Care Package",
      name: "carePackageId",
      validation: "required",
      option: carePackageOptions || [],
    },
    {
      type: "normal",
      label: "Validity Period (Months)",
      name: "period",
      value:formData?.period ? `${formData.period}` : "N/A",
      disabled:true
    },
    {
      type: "select",
      label: "Payment Mode",
      name: "paymentMode",
      validation: "required",
      option: paymentModes,
    },
    {
      type: "normal",
      label: "Transaction Number",
      name: "transactionId",
    },
  ];

  // Update validity period based on selected care package
  useEffect(() => {
    const selectedCarePackage = carePackageOptions?.find(
      (item) => item.value == formData?.carePackageId
    );
    if (selectedCarePackage) {
      setFormData((prevData) => ({
        ...prevData,
        period: selectedCarePackage.validityPeriod,
      }));
    }
  }, [formData?.carePackageId, carePackageOptions, setFormData]);

  const handleSubmit = async () => {
    setSubmit(true)
    if(!formData.carePackageId || !formData.paymentMode){
      return;
    }
    try {
      await addPatientCarePackages({
        ...formData,
        patientId: id,
        activeStatus: "1",
      }).unwrap();
      refetchCarePackage();
      openSnackBar("Created successfully");
      setTimeout(() => {
        setShowAdd(false);
      }, 350);
    } catch (error: any) {
      console.log(error, "error");
      if (error?.status === 400) {
        openSnackBar(error?.data?.error, "error");
      } else {
        setShowAdd(false);
      }
    }
  };
 
  const filterFields=formData?.paymentMode ==='Online Payment' ? fields:fields.filter((field)=>field.name !=='transactionId')

  return (
    <div>
      <BackdropLoader loader={addLoading} />
      <Toast open={open} type={type} message={message} />
      {filterFields.map((field, index) => (
        <div className="col-12" key={index}>
          <CustomInputs
            labelKey="label"
            valueKey="value"
            {...field}
            {...formData}
            onChange={handleChange}
            submit={submit}
            setFormData={setFormData}
          />
        </div>
      ))}
      <div className="mt-3 d-flex gap-3 justify-content-end">
        <button
          type="submit"
          className={`btn btn border`}
          onClick={() => setShowAdd(false)}
        >
          Cancel
        </button>
        <CustomVioletButton
          btnLabel="Assign Package"
          onClick={handleSubmit} // Call handleSubmit on button click
          isLoading={addLoading} // Show loading state if the mutation is in progress
        />
      </div>
    </div>
  );
};

export default AddCarePackages;
